// extracted by mini-css-extract-plugin
export default {"box":"ActionContent_box__WGNWY","title":"ActionContent_title__MOBDN"};